import { render, staticRenderFns } from "./billing-current-plan-card.vue?vue&type=template&id=371d51e6&scoped=true&lang=pug"
import script from "./billing-current-plan-card.vue?vue&type=script&lang=js"
export * from "./billing-current-plan-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371d51e6",
  null
  
)

export default component.exports